import React from 'react';
import { useCloudampDataRef } from '../../../hooks/useCloudampData';

/**
 * SelfScheduleConsultStub (WEBDEV-3681)
 *
 * Rendered in place of the ConsultationForm when the self-schedule variant is
 * active. Keeps a hidden cloudamp target on the page so the cloudamp library
 * still has a field to populate once the real form is removed. It reuses
 * useCloudampDataRef — the same hook the real ConsultationForm uses — so the
 * populate → poll → persist-to-localStorage cycle still runs and downstream
 * forms (e.g. /specials/estimate) keep getting attribution data.
 *
 * Usage:
 * - Global-form pages: Layout renders this when useSelfScheduleFlags().active is
 *   true and onPageFormActive is false.
 * - Pages that render their own ConsultationForm (e.g. /, /lp/google-v2): render
 *   this instead of the form under the same condition. Render exactly one stub
 *   per page so only one cloudamp field drives the populate cycle.
 */
export function SelfScheduleConsultStub() {
    const cloudampDataRef = useCloudampDataRef();
    return (
        <form style={{ display: 'none' }}>
            <input ref={cloudampDataRef} type="hidden" name="cloudamp__data__c" />
        </form>
    );
}

export default SelfScheduleConsultStub;
